const SectionTitleComponent = (props) => {
    return (
        <div className="section-title" data-aos="fade-up">
            <p>{props.children}</p>
        </div>
    );
}

export default SectionTitleComponent;